import { faqs } from '@/mocks/melons';

export default function Faq() {
  return (
    <section id="faq" className="scroll-mt-20 bg-background-50 py-12 md:py-16">
      <div className="container-page">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex flex-col items-start gap-3 lg:sticky lg:top-24">
              <span className="inline-flex items-center gap-2 rounded-full border border-secondary-200 bg-secondary-100 px-3 py-1 text-xs font-medium tracking-wide text-secondary-900">
                <i className="ri-question-line" aria-hidden="true" />
                FAQ · 吃瓜指南
              </span>
              <h2 className="text-2xl font-bold leading-snug text-foreground-950 md:text-[34px] md:leading-snug">
                关于吃瓜
                <br />
                你可能想问
              </h2>
              <p className="text-sm leading-relaxed text-foreground-600">
                关于瓜料来源、更新频率与理性吃瓜的边界，这里整理了几个高频问题，方便你快速了解快手吃瓜瓜料大全。
              </p>
              <a href="/about" className="mt-2 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700 hover:text-primary-800">
                了解更多
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {faqs.map((f) => (
                <details
                  key={f.q}
                  className="group rounded-2xl border border-background-200 bg-background-100 px-5 py-4 transition-colors open:bg-background-50 open:border-primary-200 md:px-6"
                >
                  <summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-[15px] font-bold text-foreground-900">
                    <span>{f.q}</span>
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-200 text-foreground-700 transition-transform duration-300 group-open:rotate-45 group-open:bg-primary-600 group-open:text-background-50">
                      <i className="ri-add-line text-base" aria-hidden="true" />
                    </span>
                  </summary>
                  <p className="mt-3 border-t border-background-200 pt-3 text-sm leading-relaxed text-foreground-600">
                    {f.a}
                  </p>
                </details>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}